class ShowPassword extends HTMLElement {
  connectedCallback() {
    const input =
      this.querySelector('#CustomerPassword') || this.querySelector('#RegisterForm-password');
    this.toggleButton = this.querySelector('[data-show-password]');

    if (input && this.toggleButton) {
      this.togglePasswordHandler = () => {
        if (input.value.trim() !== '') {
          const isPassword = input.type === 'password';
          input.type = isPassword ? 'text' : 'password';
          this.toggleButton.setAttribute(
            'aria-label',
            isPassword ? 'Hide password' : 'Show password'
          );
        }
      };

      this.toggleButton.addEventListener('click', this.togglePasswordHandler);
    }
  }

  disconnectedCallback() {
    if (this.toggleButton && this.togglePasswordHandler) {
      this.toggleButton.removeEventListener('click', this.togglePasswordHandler);
    }
  }
}

customElements.define('show-password', ShowPassword);
